
/**
 * 플랫폼 지원
 */
export type UpdateCourseDraft200LocalizedSectionsItemLecturesItemPlatformSupport = typeof UpdateCourseDraft200LocalizedSectionsItemLecturesItemPlatformSupport[keyof typeof UpdateCourseDraft200LocalizedSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200LocalizedSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
